import React, { useState, useEffect } from 'react';
import moment from 'moment';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import FichaTransportadorContainer from './components/FichaTransportadorContainer';
import Loading from '../../../components/Loading/Loading';
import NovoTransportador from './NovoTransportador';

//Api
import transportador_api from '../../../api/transportador_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';

export default function FichaTransportador({ btnVoltar, id = null, permissao }) {
    //Dados do usuario logado no sistema
    const { session, setupVariavel } = useAuth();

    //estado para edição dos dados do transportador
    const [editar, setEditar] = useState(false);

    //loading para as requisições mais demoradas
    const [loading, setLoading] = useState(true);

    //estado para guardar os dados do transportador
    const [transportador, setTransportador] = useState({});

    //carrega os dados do transportador
    const loadTransportador = () => {
        setLoading(true);
        transportador_api.GetItem(id ? id : session?.acesso?.acesso_id).then(response => {
            response.data.credenciamentoValidade = moment(response.data.credenciamentoValidade).format("YYYY-MM-DD");
            response.data.operacaoValidade = moment(response.data.operacaoValidade).format("YYYY-MM-DD");
            setTransportador(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //carrega os dados do transportador assim que a tela é inicializada
    useEffect(() => {
        loadTransportador();
    }, []);
    //apresenta o Loading na tela de acordo com o estado de loading
    if (loading) {
        return <Loading />
    }
    // carrega a tela de editar o transportador de acordo com o estado editar
    if (editar) {
        return <NovoTransportador transportadorParam={transportador} btnVoltar={btnVoltar} />
    }

    return (
        <MainCard btnVoltar={btnVoltar} btnEditar={permissao === "Editar" && !setupVariavel?.integracaoCadastros ? () => setEditar(true) : null} >
            <FichaTransportadorContainer transportador={transportador} veiculos={transportador.veiculos} />
        </MainCard>
    )
}